"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _constants = require("../../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var selectedDaysOfWeek = function selectedDaysOfWeek(daysOfWeek,
// @ts-expect-error - TS7006 - Parameter 'dayChanging' implicitly has an 'any' type.
dayChanging) {
  if (!Array.isArray(daysOfWeek)) {
    daysOfWeek = [];
  }
  if (daysOfWeek.indexOf(dayChanging) > -1) {
    return daysOfWeek.filter(function (day) {
      return day !== dayChanging;
    });
  }
  return [].concat((0, _toConsumableArray2["default"])(daysOfWeek), [dayChanging]);
};
var DaysOfWeekPicker = function DaysOfWeekPicker(props) {
  var hasErrors = props.hasErrors,
    daysOfWeek = props.daysOfWeek,
    onChange = props.onChange,
    options = props.options;
  var isDayActive = function isDayActive(dayValue) {
    return selectedDaysOfWeek(daysOfWeek, null).includes(dayValue);
  };
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, options.map(function (_ref) {
    var label = _ref.label,
      value = _ref.value;
    return /*#__PURE__*/_react["default"].createElement(DayIcon, {
      key: value
      // @ts-expect-error - TS2769 - No overload matches this call.
      ,
      active: isDayActive(value),
      "data-active": isDayActive(value),
      hasErrors: hasErrors,
      onClick: function onClick() {
        return onChange(selectedDaysOfWeek(daysOfWeek, value));
      }
    }, label);
  }));
};
DaysOfWeekPicker.defaultProps = {
  hasErrors: false
};
var _default = exports["default"] = DaysOfWeekPicker;
var DayIcon = _styledComponents["default"].div.withConfig({
  displayName: "days_of_week_picker__DayIcon"
})(["align-items:center;background-color:", ";border:", ";border-radius:50%;box-sizing:border-box;", " color:", ";cursor:pointer;display:inline-flex;font-size:12px;height:24px;justify-content:center;margin-right:0.5rem;padding:0.5rem;width:24px;"], function (props) {
  return (
    // @ts-expect-error - TS2339 - Property 'active' does not exist on type 'ThemedStyledProps<Pick<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, "key" | keyof HTMLAttributes<HTMLDivElement>> & { ...; }, DefaultTheme>'.
    props.active ? _constants.colors.mediumGreenhouseGreen : _constants.colors.lightGrey
  );
}, function (props) {
  return (
    // @ts-expect-error - TS2339 - Property 'hasErrors' does not exist on type 'ThemedStyledProps<Pick<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, "key" | keyof HTMLAttributes<HTMLDivElement>> & { ...; }, DefaultTheme>'.
    props.hasErrors ? (0, _styledComponents.css)(["1px solid ", ""], _constants.colors.darkRed) : undefined
  );
}, /* @ts-expect-error Flow -> TS migration */'', function (props) {
  return props.active ? _constants.colors.white : _constants.colors.darkestGrey;
});